import React from 'react';
import { PixelRatio, View } from 'react-native';
import { Button, useTheme } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import ActivePaymentMethodRow from './PaymentMethodRow';
import { ProductSubscription } from '../../types/appsync-types';
import Typography from '../../components/Typography';
import { styles } from './sharedCardConfig';
import { useI18n } from '../../context/I18nContext';
import Spacer from '../../components/Spacer';
import GradientButton from '../../components/GradientButton';
import { AppDrawerNavigationProp } from '../../components/DrawerMenuContent';
import { screenNames } from '../../navigators/screenNames';
import { useActivePayment } from '../../payment/MapViewActivePaymentContext';

type Props = {
  reservation: ProductSubscription | undefined | null;
  podId: string | undefined | null;
};

export const UnpaidReservationContent = ({ reservation, podId }: Props) => {
  const { I18n } = useI18n();
  const { colors } = useTheme();
  const navigation = useNavigation<AppDrawerNavigationProp>();
  const { activePaymentMethod } = useActivePayment();
  const hasLargeFont = PixelRatio.getFontScale() > 2;

  return (
    <>
      <View style={[styles.scheduleSection, { flexDirection: hasLargeFont ? 'column' : 'row' }]}>
        <Typography variant={'body1'}>{I18n.t('mapview.podInfoCard.unpaidTitle')}</Typography>
      </View>
      <Spacer />

      {!!reservation?.productId && (
        <>
          <ActivePaymentMethodRow
            paymentMethod={activePaymentMethod}
            onPress={() => navigation.navigate('map', { screen: screenNames.PaymentChangeBeforeCheckoutView })}
          />
          <GradientButton
            onPress={() => {
              navigation.navigate('map', {
                screen: screenNames.ConfirmReservationProductDialog,
                params: {
                  id: reservation.productId,
                },
              });
            }}
          >
            {I18n.t('mapview.podInfoCard.pay')}
          </GradientButton>
        </>
      )}
      <View style={styles.cardAction}>
        <Button
          labelStyle={{
            color: colors.onBackground,
          }}
          onPress={() => {
            if (reservation?.productId) {
              navigation.navigate('map', {
                screen: screenNames.ReservationProductDetailScreen,
                params: {
                  productId: reservation.productId,
                },
              });
            } else if (podId) {
              navigation?.navigate('map', {
                screen: screenNames.OneTimePurchaseProductsScreen,
                params: {
                  filter: 'active',
                  podId,
                },
              });
            }
          }}
        >
          {I18n.t('mapview.podInfoCard.viewBooking')}
        </Button>
      </View>
    </>
  );
};
